export enum InvoiceStatus {
	Draft = 1,
	Flagged = 2,
	Ready = 3,
	Submitted = 4,
	Processed = 5,
	Pending = 6
}
